import styled, { css } from 'styled-components'
import { Row, Column } from '@sainsburys-tech/bolt'
import { remCalculator, createBorder } from '../../../helpers/theming/utilities'
import { NectarHeading } from '../../../helpers/StyledWrappers.styles'

const imageMobileSpacing = (theme) => `${parseInt(theme.size.spacing.md, 10) / 2}px`

const Wrapper = styled.div`
  padding-bottom: ${(props) => props.theme.size.spacing.lg};
`

const Heading = styled.h2`
  ${NectarHeading}
  margin-right: auto;
`

const HeadingWrapper = styled.header`
  ${(props) =>
    css`
      @media screen and (min-width: ${props.theme.size.breakpoint['min-width'].sm}) {
        display: flex;
        width: 100%;
        margin-right: ${props.theme.size.spacing.lg};
        align-items: center;
    `}
`

const MoreInspirationLink = styled.span`
  display: none;
  ${(props) =>
    css`
      @media screen and (min-width: ${props.theme.size.breakpoint['min-width'].sm}) {
        display: inline;
    `}
`

const MoreLinkWrapper = styled.div`
  display: flex;
  justify-content: center;
  padding: 10px 0;
`

const MoreInspirationLinkAlt = styled.span`
  ${(props) =>
    css`
      @media screen and (min-width: ${props.theme.size.breakpoint['min-width'].sm}) {
        display: none;
    `}
`

const ImagesWrapper = styled(Column)`
  ${(props) =>
    css`
      @media screen and (min-width: ${props.theme.size.breakpoint['min-width'].sm}) {
        position: relative;
    `}

  ${(props) =>
    !props.hasImages &&
    css`
      display: flex;
      align-items: center;
    `}
`

const ImageWrapper = styled(Column)`
  width: 100%;
  height: 168px;
  float: left;
  position: relative;
  top: 0;
  left: 0;

  ${(props) =>
    css`
      margin-top: ${remCalculator(props.theme.size.spacing.md)};

      @media screen and (min-width: ${props.theme.size.breakpoint['min-width'].sm}) {
        height: 340px;
        margin-top: 0;
      }

      @media screen and (min-width: ${props.theme.size.breakpoint['min-width'].md}) {
        display: block;

        ${props.isOnlyImage &&
        css`
          padding-right: ${props.theme.size.spacing.lg}px;
        `}
      }
    `}

  ${(props) =>
    props.imageColumns !== '12' &&
    css`
      @media screen and (max-width: ${props.theme.size.breakpoint['max-width'].xs}) {
        max-width: calc(50% - ${imageMobileSpacing(props.theme)});

        ${props.type === 'secondary' &&
        css`
          margin-right: ${imageMobileSpacing(props.theme)};
        `}

        ${props.type === 'tertiary' &&
        css`
          margin-left: ${imageMobileSpacing(props.theme)};
        `}
      }
    `}

  img {
    background-position: center center;
    background-size: cover;
    background-repeat: no-repeat;
    z-index: 1;
    text-indent: -9999px;
    object-fit: cover;
  }
`

const HighlightImageWrapper = styled(Row)`
  ${(props) =>
    css`
      @media screen and (min-width: ${props.theme.size.breakpoint['min-width'].sm}) {
        position: absolute;
        top: 240px;
        left: -95px;
        z-index: 2;

        img {
          height: 225px;
          width: 225px;
          border-radius: 50%;
          background: ${props.theme.color.monochrome.white};
          ${createBorder('10px', props.theme.color.monochrome.white)}
        }
      }
    `}
`

const BodyWrapper = styled.div`
  margin-bottom: ${(props) => props.theme.size.spacing.md};
  clear: both;

  ${(props) =>
    css`
      @media screen and (min-width: ${props.theme.size.breakpoint['min-width'].sm}) {
        margin-left: 15px;
        padding: 20px;
        background: ${props.theme.color.monochrome.white};
        border-radius: ${props.theme.size.border.radius.base}
        position: relative;
        top: 25px;
        height: 215px;
        overflow-y: auto;
      }
    `}

  ${(props) =>
    props.noTertiaryPush &&
    css`
      @media screen and (min-width: ${props.theme.size.breakpoint['min-width'].sm}) {
        margin-right: 15px;
      }
    `}

  ${(props) =>
    props.highlightPush &&
    css`
      @media screen and (min-width: ${props.theme.size.breakpoint['min-width'].md}) {
        padding: 30px;
      }
    `}
`

const SubHeading = styled.h3`
  padding-top: 28px;
  margin-bottom: 15px;

  ${(props) =>
    css`
      @media screen and (min-width: ${props.theme.size.breakpoint['min-width'].sm}) {
        padding-top: 0;
      }
    `}

  ${(props) =>
    props.highlightPush &&
    css`
      @media screen and (min-width: ${props.theme.size.breakpoint['min-width'].lg}) {
        padding-left: 85px;
        min-height: 45px;
      }
    `}
`

const Body = styled.p`
  ${(props) =>
    css`
      @media screen and (min-width: ${props.theme.size.breakpoint['min-width'].md}) {
        margin-top: ${remCalculator(props.theme.size.spacing.lg)};
      }
    `}

  ${(props) =>
    props.highlightCopyPad &&
    css`
      @media screen and (min-width: ${props.theme.size.breakpoint['min-width'].md}) {
        padding-left: 75px;
      }
    `}
`

export {
  Wrapper,
  Heading,
  HeadingWrapper,
  MoreInspirationLink,
  MoreLinkWrapper,
  MoreInspirationLinkAlt,
  ImagesWrapper,
  HighlightImageWrapper,
  ImageWrapper,
  BodyWrapper,
  SubHeading,
  Body
}
